<template>
    <div
        tabindex="-1"
        aria-labelledby="offcanvasAddUserLabel"
    >
        <div class="offcanvas-header border-bottom">
            <h5 id="offcanvasAddUserLabel" class="offcanvas-title">
                FORM CEK LOG SARANA
            </h5>
        </div>
        <div class="offcanvas-body mx-0 flex-grow-0 p-6 h-100">
            <div class="col-xl">
                <form
                    @submit.prevent="send"
                    autocomplete="off"
                    autocapitalize="on"
                >
                    <div class="mb-3">
                        <label class="form-label" for="nomorLambung"
                            >UNIT SARANA (LIGHT VEHICLES)
                        </label>
                        <input
                            type="hidden"
                            name="_token"
                            v-model="csrfTokens"
                        />
                        <select
                            class="form-control"
                            id="nomorLambung"
                            name="kodeUnit"
                            placeholder="NOMOR LAMBUNG"
                            @change="selectSarana($event)"
                            required="required"
                            v-model="ceklog.kodeUnit"
                        >
                        <option value="" selected="selected">-- Pilih --</option>
                        <option  v-for="(i,k) in sarana" :value="k"> {{ i }}</option>
                    </select>
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="kmMeter">Kilometer Unit</label>
                        <input
                            type="text"
                            class="form-control"
                            id="kilometerUnit"
                            v-model="ceklog.kilometerUnit"
                            placeholder="Kilometer Unit"
                            required="required"
                            @keypress="isNumber($event)"
                        />
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="merkType">MEREK - Type</label>
                        <input
                            type="text"
                            class="form-control"
                            id="merkType"
                            v-model="ceklog.merkType"
                            placeholder="MEREK - Type"
                            required="required"
                            readonly="readonly"
                        />
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="tanggal"
                            >Tanggal</label
                        >
                        <input
                            type="date"
                            class="form-control"
                            id="tanggal"
                            v-model="ceklog.tanggal"
                            required="required"
                            readonly="readonly"
                        />
                    </div>

                    <div class="mb-3">
                        <label class="form-label" for="jam">Waktu</label>
                        <input
                            type="time"
                            class="form-control"
                            id="jam"
                            v-model="ceklog.jam"
                            placeholder="Waktu"
                            step="2"
                            required="required"
                            readonly="readonly"
                        />
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="Pengemudi">Pengemudi</label>
                        <input
                            type="text"
                            class="form-control"
                            id="driver"
                            v-model="ceklog.driver"
                            placeholder="Pengemudi"
                            step="2"
                            required="required"
                            readonly="readonly"
                        />
                    </div>



                    <button
                        type="submit"
                        class="btn btn-primary me-3 data-submit"
                    >
                        Submit
                    </button>
                    <button
                        type="reset"
                        class="btn btn-outline-danger"
                        data-bs-dismiss="offcanvas"
                    >
                        Cancel
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
    mounted() {
        if (this.username != "")
            this.users = JSON.parse(this.username);

        this.getSarana();
        if(this.idsarana!=null) this.ceklog.kodeUnit=this.idsarana
    },
    data() {
        return {
            moment:moment,
            strTime:new Date(),
            urlAction: "/",
            csrfTokens: "",
            ceklog: {},
            sarana: [],
            vehicle : [],
            chkStatus: true,
            idVehicles: null,
            users:{},
            dtime:new Date(),
            idSarana:null
        };
    },
    props: ["tokens", "url_action","username","idsarana"],
    methods: {
        send() {
                 this.save();
        },
        save() {
            axios.post("/sarana/ceklog", this.ceklog).then((response) => {
                var data = response.data;
                if (data.success) {
                    document.location = data.uri
                }
            });
        },
        getSarana() {
            this.initDatas();
            axios
                .get("/sarana/lv/show")
                .then((response) => {
                    var v = response.data;
                    if (v != null) {
                        var s = {};
                        var vhc = {};
                        for(var i in v){
                            s[v[i].uidVehicle] = v[i].noLambung + " ("+v[i].noPol+")"
                            vhc[v[i].uidVehicle]= v[i].merek + " ("+v[i].type+")"
                        }
                        this.sarana = s
                        this.vehicle = vhc
                    }
                    this.changeSarana(this.ceklog.kodeUnit)
                });
        },
        getUid() {
            axios.get("/get/uids").then((response) => {
                this.ceklog.uidVehicle = response.data;
            });
        },
        isNumber(evt) {
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57)
            ) {
                evt.preventDefault();
            }
            },
        updateData() {
            this.$emit("tabelSaranaEmit");
        },
        focusInputs() {
            this.$refs.kodeUnit.focus();
        },

        chgStatus() {
            this.chkStatus != this.chkStatus;
            if (this.chkStatus) {
                this.ceklog.statusCeklog = 1;
            } else {
                this.ceklog.statusCeklog = 0;
            }
        },
        selectSarana(e){
            var v = this.vehicle[e.target.value]
            this.ceklog.noLambung = this.sarana[e.target.value];
            this.ceklog.merkType = v
            this.ceklog.kodeUnit = e.target.value;
            console.log("A : "+this.ceklog.kodeUnit)
        },
        changeSarana(e){
            var v = this.vehicle[e]
            this.ceklog.noLambung = this.sarana[e];
            this.ceklog.merkType = v
            this.ceklog.kodeUnit = e;
            console.log("A : "+this.sarana)
        },

        initDatas() {
            var hari=['Minggu', 'Senin','Selasa','Rabu','Kamis','Jumat','Sabtu'];
            var time =this.pad(this.dtime.getHours())+':'+this.pad(this.dtime.getMinutes())+':'+this.pad(this.dtime.getSeconds())
            var dt = moment().format('YYYY-MM-DD')

            this.ceklog = {};
            if (this.url_action != null) {
                this.urlAction = this.url_action;
            }
            if (this.tokens != null) {
                this.csrfTokens = this.tokens;
            }
            this.ceklog.kodeUnit = "";
            this.ceklog.status = 1;
            this.ceklog.tanggal =dt
            this.ceklog.jam = time
            this.ceklog.hari = hari[this.dtime.getDay()];
            this.ceklog.nikDriver = this.users.username
            this.ceklog.driver = this.users.fullName
            this.getUid();
        },
        pad(d) {
            return (d < 10) ? '0' + d.toString() : d.toString();
        }
    },
    expose: ["initDatas", "getByIds", "focusInputs"],
};
</script>